import React from 'react'

import Clients from './components/Clients'
import ManagementClient from './components/ManagementClient'
import Address from './components/Address'
import Demand from './components/Demand'

import { ReactComponent as Management } from 'assets/icons/people.svg'
import { ReactComponent as Location } from 'assets/icons/location.svg'
import { ReactComponent as DemandIcon } from 'assets/icons/shipping.svg'

import './styles/Clients.scss'

const client: React.FC = () => {
  return (
    <div className="row manageclient">
      <ManagementClient />

      <div className="row justify-start margin-top-16">
        <h2><Management height="20" width="35" />Cliente</h2>
      </div>

      <Clients />

      <div className="row justify-start margin-top-16">
        <h2><Location height="20" width="35" /> Endereços</h2>
      </div>

      <Address />

      <div className="row margin-top-16 align-end demands">
        <div style={{ flexDirection: 'column' }} className="row col-6">
          <div className="row justify-start">
            <h2><DemandIcon height="20" width="35" /> Pedidos</h2>
          </div>
          <p className="row justify-start">Selecione um período de tempo para filtrar os pedidos</p>
        </div>

        <div className="row col-6 align-end">
          <div className="form-control col-5">
            <p>De</p>
            <input type="number"/>
          </div>
          <div className="form-control col-5">
            <p>até</p>
            <input type="number"/>
          </div>
          <div className="row col-2 ">
            <span
              className="button primary align-center btn-client"
              style={{ width: 190, fontSize: 16 }}>
              <i className="fas fa-1x fa-filter" /> Filtrar
            </span>
          </div>
        </div>
      </div>

      <Demand />

    </div>
  )
}

export default client
